import { ThirdParty } from '../../entity/third-party';

export class ProducerAutocompleteSearchResult {
    public selectedProducer: ThirdParty;
    public fetchedProducers: ThirdParty[];
    public search: string;

    constructor(selectedProducer: ThirdParty, fetchedProducers: ThirdParty[], search: string) {
        this.selectedProducer = selectedProducer;
        this.fetchedProducers = fetchedProducers;
        this.search = search;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/producers/producer-autocomplete-search-result.ts